export const STOP_DESTINATION_MAX_LENGTH = 11;
export const TRIP_OPERATION_NOTES_MAX_LENGTH = 250;
